import React from 'react';
import {Button, Container, Form, FormControl, Navbar} from "react-bootstrap";
import {NavLink} from 'react-router-dom';
import './Header.css';
import logo from '../../images/logo-icon.png';

const Header = () => {
    return (
        <div>
            <Navbar collapseOnSelect expand="lg" bg="light">
                <Container>
                    <Navbar.Brand href="">
                        <img
                            src={logo}
                            width="100"
                            className="d-inline-block align-top"
                            alt="logo"
                        />
                    </Navbar.Brand>
                    <Navbar.Toggle aria-controls="basic-navbar-nav"/>
                    <Navbar.Collapse id="basic-navbar-nav">
                        <nav className="me-auto g-4 nav-btn">
                            <NavLink to="/home">Home</NavLink>
                            <NavLink to="/services">Services</NavLink>
                            <NavLink to="/category">Category</NavLink>
                            <NavLink to="/about">About Us</NavLink>
                        </nav>
                        <Form className="d-flex">
                            <FormControl
                                type="search"
                                placeholder="Search Course"
                                className="me-2"
                                aria-label="Search"
                            />
                            <Button variant="outline-primary">Search</Button>
                        </Form>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </div>
    );
};

export default Header;
